import { createFileRoute, redirect } from '@tanstack/react-router';
import { ContractQboFields } from '@/components/settings/accounting/RecurringRevenueSettings';
import { ContractSettingsTabShell } from '@/components/settings/contracts/ContractSettingsTabShell';

/**
 * Spec §14.4 — QBO tab. Deferred-revenue toggle, recognition basis,
 * subscription recognition, GL accounts and items, tax-exempt handling.
 */

export const Route = createFileRoute('/_dashboard/dashboard/settings/contracts/qbo')({
  beforeLoad: () => {
    throw redirect({ to: '/dashboard/settings/accounting' });
  },
  component: ContractQboPage,
});

function ContractQboPage() {
  return (
    <ContractSettingsTabShell
      tab="qbo"
      title="QuickBooks Online"
      render={(draft, update) => <ContractQboFields draft={draft} update={update} />}
    />
  );
}
